import React, { Component } from 'react';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FormCreateMapping from './FormCreateMapping';

const MATCH_MODES = [
    { value: 'single', label: 'Simple (trae datos de un registro)' },
    { value: 'aggregate', label: 'Avanzado (agrega valores de N registros)' },
];

const OPERATIONS = [
    { value: 'suma', label: 'Suma' },
    { value: 'promedio', label: 'Promedio' },
    { value: 'maximo', label: 'Maximo' },
    { value: 'minimo', label: 'Minimo' },
    { value: 'contador', label: 'Contador' },
    { value: 'valor', label: 'Valor' },
    { value: 'ultimo', label: 'Ultimo' },
    { value: 'primero', label: 'Primero' },
];

class FormCreate extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;

        const s = props.modeEdit && props.search ? props.search : null;

        this.state = {
            activeTab: 'config',
            match_mode: s ? s.match_mode : 'single',
            operation: s ? s.operation : 'suma',
            format_source_id: s && s.format_source_info ? s.format_source_info.id : "",
            question_compare_id: s && s.question_compare_info ? s.question_compare_info.id : "",
            question_compare_source_id: s && s.question_compare_source_info ? s.question_compare_source_info.id : "",

            selectedMatchMode: s ? MATCH_MODES.find(m => m.value === s.match_mode) : MATCH_MODES[0],
            selectedOperation: s ? OPERATIONS.find(op => op.value === s.operation) : OPERATIONS[0],
            selectedFormatSource: s && s.format_source_info ? { label: s.format_source_info.name, value: s.format_source_info.id } : null,
            selectedQuestionCompare: s && s.question_compare_info ? { label: s.question_compare_info.name, value: s.question_compare_info.id } : null,
            selectedQuestionCompareSource: s && s.question_compare_source_info ? { label: s.question_compare_source_info.name, value: s.question_compare_source_info.id } : null,

            formats: [],
            currentFormatQuestions: [],
            sourceFormatQuestions: [],

            search: s,
            showMappingForm: false,
            editMapping: null,
            mappings: s && s.format_search_v2_mappings ? s.format_search_v2_mappings : [],
        };
    }

    componentDidMount = () => {
        this.loadFormats();
        this.loadCurrentFormatQuestions();
        if (this.state.format_source_id) {
            this.loadSourceFormatQuestions(this.state.format_source_id);
        }
    }

    loadFormats = () => {
        const raw = this.props.formatos || [];
        // Soporta ambos formatos: ya-wrapped [{label, value}] o raw [{id, name}]
        const formats = raw.map(f => {
            if (f.label !== undefined && f.value !== undefined) return f;
            return { label: f.name, value: f.id };
        });
        this.setState({ formats });
    }

    loadCurrentFormatQuestions = () => {
        fetch(`/formatos/data_questions/${this.props.format.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                this.setState({
                    currentFormatQuestions: data.steps_questions.map(q => ({
                        label: q.question, value: q.id, question_type: q.question_type
                    }))
                });
            });
    }

    loadSourceFormatQuestions = (formatId) => {
        fetch(`/formatos/data_questions/${formatId}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                this.setState({
                    sourceFormatQuestions: data.steps_questions.map(q => ({
                        label: q.question, value: q.id, question_type: q.question_type
                    }))
                });
            });
    }

    handleFormatSourceChange = (opt) => {
        this.setState({
            selectedFormatSource: opt,
            format_source_id: opt ? opt.value : "",
            selectedQuestionCompareSource: null,
            question_compare_source_id: "",
            sourceFormatQuestions: [],
        });
        if (opt) this.loadSourceFormatQuestions(opt.value);
    }

    handleSaveConfig = () => {
        const { format_source_id, question_compare_id, question_compare_source_id, match_mode, operation } = this.state;
        if (!format_source_id || !question_compare_id || !question_compare_source_id || !match_mode) return;

        const body = {
            format_id: this.props.format.id,
            format_source_id,
            question_compare_id,
            question_compare_source_id,
            match_mode,
            operation,
        };

        const isCreate = !this.state.search;
        const url = isCreate ? '/formatos/format_search_v2s' : `/formatos/format_search_v2s/${this.state.search.id}`;
        const method = isCreate ? 'POST' : 'PATCH';

        fetch(url, {
            method,
            body: JSON.stringify(body),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1200 });
                if (data.register) {
                    this.setState({
                        search: data.register,
                        mappings: data.register.format_search_v2_mappings || [],
                    });
                    if (isCreate && this.props.onCreated) this.props.onCreated(data.register);
                    else if (!isCreate && this.props.onUpdated) this.props.onUpdated(data.register);
                }
            });
    }

    handleMappingCreated = (register) => {
        this.setState({
            mappings: [...this.state.mappings, register],
            showMappingForm: false,
            editMapping: null,
        });
    }

    handleMappingUpdated = (register) => {
        this.setState({
            mappings: this.state.mappings.map(m => m.id === register.id ? register : m),
            showMappingForm: false,
            editMapping: null,
        });
    }

    handleMappingDelete = (mappingId) => {
        Swal.fire({
            title: "Eliminar mapeo?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Si",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_search_v2_mappings/${mappingId}`, {
                    method: 'DELETE',
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                    .then(r => r.json())
                    .then(() => {
                        this.setState({ mappings: this.state.mappings.filter(m => m.id !== mappingId) });
                    });
            }
        });
    }

    render() {
        const canSaveConfig = this.state.format_source_id && this.state.question_compare_id && this.state.question_compare_source_id;
        const isAggregate = this.state.match_mode === 'aggregate';
        const hasSearch = !!this.state.search;

        return (
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 16, marginBottom: 16, background: '#fafbfc' }}>
                <div style={{ display: 'flex', borderBottom: '2px solid #e5e7eb', marginBottom: 16 }}>
                    <button
                        onClick={() => this.setState({ activeTab: 'config' })}
                        style={{ padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
                                 fontWeight: this.state.activeTab === 'config' ? 600 : 400,
                                 borderBottom: this.state.activeTab === 'config' ? '2px solid #3498db' : 'none',
                                 color: this.state.activeTab === 'config' ? '#3498db' : '#999' }}>
                        Configuracion del campo
                    </button>
                    <button
                        onClick={() => this.setState({ activeTab: 'filter' })}
                        style={{ padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
                                 fontWeight: this.state.activeTab === 'filter' ? 600 : 400,
                                 borderBottom: this.state.activeTab === 'filter' ? '2px solid #3498db' : 'none',
                                 color: this.state.activeTab === 'filter' ? '#3498db' : '#999' }}>
                        Mapeos y filtros
                    </button>
                </div>

                {this.state.activeTab === 'config' && (
                    <React.Fragment>
                        <p style={{ fontSize: 13, color: '#666', margin: '0 0 16px 0' }}>
                            Configura una busqueda que trae valores desde otro formato comparando preguntas.
                        </p>

                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Modo</label>
                                <Select
                                    options={MATCH_MODES}
                                    value={this.state.selectedMatchMode}
                                    onChange={(opt) => this.setState({ selectedMatchMode: opt, match_mode: opt ? opt.value : 'single' })}
                                    className="link-form"
                                />
                            </div>

                            {isAggregate && (
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Operacion global</label>
                                    <Select
                                        options={OPERATIONS}
                                        value={this.state.selectedOperation}
                                        onChange={(opt) => this.setState({ selectedOperation: opt, operation: opt ? opt.value : 'suma' })}
                                        className="link-form"
                                    />
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Formato fuente</label>
                                <Select
                                    options={this.state.formats}
                                    value={this.state.selectedFormatSource}
                                    onChange={this.handleFormatSourceChange}
                                    placeholder="Seleccione formato..."
                                    className="link-form"
                                    isClearable
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Pregunta disparadora (este formato)</label>
                                <Select
                                    options={this.state.currentFormatQuestions}
                                    value={this.state.selectedQuestionCompare}
                                    onChange={(opt) => this.setState({ selectedQuestionCompare: opt, question_compare_id: opt ? opt.value : "" })}
                                    placeholder="Pregunta..."
                                    className="link-form"
                                    isClearable
                                />
                                <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Al perder foco en esta pregunta se dispara la busqueda</span>
                            </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Pregunta a comparar (formato fuente)</label>
                            <Select
                                options={this.state.sourceFormatQuestions}
                                value={this.state.selectedQuestionCompareSource}
                                onChange={(opt) => this.setState({ selectedQuestionCompareSource: opt, question_compare_source_id: opt ? opt.value : "" })}
                                isDisabled={!this.state.format_source_id}
                                placeholder={!this.state.format_source_id ? "Seleccione formato fuente primero" : "Pregunta..."}
                                className="link-form"
                                isClearable
                            />
                            <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta del formato fuente que se compara contra la disparadora</span>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <button className="btn btn-outline-danger btn-sm" onClick={this.props.onClose}>
                                Cancelar
                            </button>
                            {canSaveConfig && (
                                <button className="btn btn-info btn-sm" onClick={this.handleSaveConfig}>
                                    {hasSearch ? "Actualizar" : "Guardar"}
                                </button>
                            )}
                        </div>
                    </React.Fragment>
                )}

                {this.state.activeTab === 'filter' && (
                    <React.Fragment>
                        {!hasSearch ? (
                            <p style={{ color: '#e67e22', fontSize: 13 }}>
                                Guarda primero la configuracion del campo para agregar mapeos y filtros.
                            </p>
                        ) : (
                            <React.Fragment>
                                <div style={{ marginBottom: 16 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                        <h6 style={{ margin: 0 }}>Mapeos (fuente → objetivo)</h6>
                                        {!this.state.showMappingForm && (
                                            <button className="btn btn-info btn-sm" onClick={() => this.setState({ showMappingForm: true, editMapping: null })}>
                                                <i className="fas fa-plus mr-1" /> Mapeo
                                            </button>
                                        )}
                                    </div>

                                    {this.state.showMappingForm && !this.state.editMapping && (
                                        <FormCreateMapping
                                            format_search_v2={this.state.search}
                                            sourceQuestions={this.state.sourceFormatQuestions}
                                            targetQuestions={this.state.currentFormatQuestions}
                                            modeEdit={false}
                                            onCreated={this.handleMappingCreated}
                                            onClose={() => this.setState({ showMappingForm: false, editMapping: null })}
                                        />
                                    )}

                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Pregunta fuente</th>
                                                <th>Pregunta objetivo</th>
                                                <th>Operacion</th>
                                                <th>Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.mappings.length === 0 ? (
                                                <tr><td colSpan="4" style={{ textAlign: 'center', color: '#999' }}>No hay registros</td></tr>
                                            ) : (
                                                this.state.mappings.map(m => (
                                                    this.state.editMapping && this.state.editMapping.id === m.id ? (
                                                        <tr key={m.id}>
                                                            <td colSpan="4">
                                                                <FormCreateMapping
                                                                    format_search_v2={this.state.search}
                                                                    sourceQuestions={this.state.sourceFormatQuestions}
                                                                    targetQuestions={this.state.currentFormatQuestions}
                                                                    modeEdit={true}
                                                                    mapping={m}
                                                                    onUpdated={this.handleMappingUpdated}
                                                                    onClose={() => this.setState({ editMapping: null })}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        <tr key={m.id}>
                                                            <td>{m.question_source_info && m.question_source_info.name}</td>
                                                            <td>{m.question_target_info && m.question_target_info.name}</td>
                                                            <td>{m.operation || (isAggregate ? '(global)' : '-')}</td>
                                                            <td>
                                                                <button className="btn btn-sm" onClick={() => this.setState({ editMapping: m })}>
                                                                    <i className="fas fa-pencil-alt" style={{ color: '#3f69d8' }} />
                                                                </button>
                                                                <button className="btn btn-sm" onClick={() => this.handleMappingDelete(m.id)}>
                                                                    <i className="fas fa-trash-alt" style={{ color: '#3f69d8' }} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default FormCreate;
